import type { z } from 'zod'
import { projectDataApi } from './projectDataApi'
import { ReportDeliveryResponseSchema, ReportDeliveryMutationSchema, type ReportDeliveryRequestSchema } from '../schemas/summaryDestinations'

const api = projectDataApi.injectEndpoints({ endpoints: builder => ({
  getReportDelivery: builder.query<z.infer<typeof ReportDeliveryResponseSchema>, string>({
    query: projectId => ({ url: '/api/project-report-delivery', params: { project_id: projectId } }),
    transformResponse: (response: unknown) => ReportDeliveryResponseSchema.parse(response),
    providesTags: (_result, _error, projectId) => [{ type: 'Project', id: projectId }],
  }),
  updateReportDelivery: builder.mutation<z.infer<typeof ReportDeliveryMutationSchema>, { projectId: string; body: z.infer<typeof ReportDeliveryRequestSchema> }>({
    query: ({ projectId, body }) => ({ url: '/api/project-report-delivery', params: { project_id: projectId }, method: 'POST', body }),
    transformResponse: (response: unknown) => ReportDeliveryMutationSchema.parse(response),
    invalidatesTags: (_result, _error, { projectId }) => [{ type: 'Project', id: projectId }],
  }),
}) })
export const { useGetReportDeliveryQuery, useUpdateReportDeliveryMutation } = api
